import s from './styles.module.scss'

export const Border = () => {
  return <div className={s.border} />
}
